/* tslint:disable */
/* eslint-disable */
/**
 * WENK.SLB.Identity.WebAPI [WENK-SIT] (0.0.932.704)
 * API for WENK.SLB.Identity.WebAPI
 *
 * The version of the OpenAPI document: 0.0.932.704
 * Contact:
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration'
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from './common'
import type { RequestArgs } from './base'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base'

/**
 *
 * @export
 * @interface AppInfoApiRs
 */
export interface AppInfoApiRs {
  /**
   *
   * @type {string}
   * @memberof AppInfoApiRs
   */
  applicationName?: string | null
  /**
   *
   * @type {string}
   * @memberof AppInfoApiRs
   */
  version?: string | null
  /**
   *
   * @type {string}
   * @memberof AppInfoApiRs
   */
  machineName?: string | null
}
/**
 * External Rq Model
 * @export
 * @interface ExternalRq
 */
export interface ExternalRq {
  /**
   * 邀請碼
   * @type {string}
   * @memberof ExternalRq
   */
  invitationCode?: string | null
  /**
   * 邀請郵件信箱
   * @type {string}
   * @memberof ExternalRq
   */
  invitationEmail?: string | null
  /**
   * 邀請檢核碼
   * @type {string}
   * @memberof ExternalRq
   */
  invitationChecksum?: string | null
}
/**
 * External Rs Model
 * @export
 * @interface ExternalRs
 */
export interface ExternalRs {
  /**
   * 執行狀態
   * @type {boolean}
   * @memberof ExternalRs
   */
  status?: boolean
  /**
   * 訊息
   * @type {string}
   * @memberof ExternalRs
   */
  message?: string | null
}
/**
 * Request Forgot Password Apply Rq Model
 * @export
 * @interface RequestForgotPasswordApplyRq
 */
export interface RequestForgotPasswordApplyRq {
  /**
   * email address
   * @type {string}
   * @memberof RequestForgotPasswordApplyRq
   */
  emailAddress: string
}
/**
 * Request Forgot Password Apply Rs Model
 * @export
 * @interface RequestForgotPasswordApplyRs
 */
export interface RequestForgotPasswordApplyRs {
  /**
   * 執行狀態
   * @type {boolean}
   * @memberof RequestForgotPasswordApplyRs
   */
  status?: boolean
  /**
   * 訊息
   * @type {string}
   * @memberof RequestForgotPasswordApplyRs
   */
  message?: string | null
}
/**
 * Request New Account Apply Rq Model
 * @export
 * @interface RequestNewAccountApplyRq
 */
export interface RequestNewAccountApplyRq {
  /**
   * 電子郵件地址
   * @type {string}
   * @memberof RequestNewAccountApplyRq
   */
  emailAddress: string
  /**
   * 邀請碼
   * @type {string}
   * @memberof RequestNewAccountApplyRq
   */
  invitationCode?: string
  /**
   * 檢核碼
   * @type {string}
   * @memberof RequestNewAccountApplyRq
   */
  checksum?: string | null
}
/**
 * Request New Account Apply Rs Model
 * @export
 * @interface RequestNewAccountApplyRs
 */
export interface RequestNewAccountApplyRs {
  /**
   * 執行狀態
   * @type {boolean}
   * @memberof RequestNewAccountApplyRs
   */
  status?: boolean
  /**
   * 訊息
   * @type {string}
   * @memberof RequestNewAccountApplyRs
   */
  message?: string | null
  /**
   * correlation id
   * @type {string}
   * @memberof RequestNewAccountApplyRs
   */
  correlationId?: string
}
/**
 * Reset Password Rq Model
 * @export
 * @interface ResetPasswordRq
 */
export interface ResetPasswordRq {
  /**
   * 電子郵件地址
   * @type {string}
   * @memberof ResetPasswordRq
   */
  emailAddress: string
  /**
   * Verification Code
   * @type {string}
   * @memberof ResetPasswordRq
   */
  verificationCode?: string
  /**
   * token
   * @type {string}
   * @memberof ResetPasswordRq
   */
  checkToken?: string | null
  /**
   * 新密碼
   * @type {string}
   * @memberof ResetPasswordRq
   */
  newPassword: string
  /**
   * 確認新密碼
   * @type {string}
   * @memberof ResetPasswordRq
   */
  confirmNewPassword: string
}
/**
 * Reset Password Rs
 * @export
 * @interface ResetPasswordRs
 */
export interface ResetPasswordRs {
  /**
   * 執行狀態
   * @type {boolean}
   * @memberof ResetPasswordRs
   */
  status?: boolean
  /**
   * 訊息
   * @type {string}
   * @memberof ResetPasswordRs
   */
  message?: string | null
}
/**
 * System Rq Model
 * @export
 * @interface SystemRq
 */
export interface SystemRq {
  /**
   * 邀請碼
   * @type {string}
   * @memberof SystemRq
   */
  invitationCode?: string | null
  /**
   * 邀請郵件信箱
   * @type {string}
   * @memberof SystemRq
   */
  invitationEmail?: string | null
  /**
   * 邀請檢核碼
   * @type {string}
   * @memberof SystemRq
   */
  invitationChecksum?: string | null
  /**
   * 密碼
   * @type {string}
   * @memberof SystemRq
   */
  newPassword: string
  /**
   * 確認密碼
   * @type {string}
   * @memberof SystemRq
   */
  confirmNewPassword: string
  /**
   * 使用者名稱
   * @type {string}
   * @memberof SystemRq
   */
  userName?: string | null
  /**
   * 手機號碼
   * @type {string}
   * @memberof SystemRq
   */
  phone?: string | null
  /**
   * Correlation Id
   * @type {string}
   * @memberof SystemRq
   */
  correlationId?: string
  /**
   * New Email
   * @type {string}
   * @memberof SystemRq
   */
  emailAddress?: string | null
  /**
   * Verification Code
   * @type {string}
   * @memberof SystemRq
   */
  verificationCode?: string | null
  /**
   * photo (base64)
   * @type {string}
   * @memberof SystemRq
   */
  photoBase64?: string | null
}
/**
 * System Rs Model
 * @export
 * @interface SystemRs
 */
export interface SystemRs {
  /**
   * 執行狀態
   * @type {boolean}
   * @memberof SystemRs
   */
  status?: boolean
  /**
   * 訊息
   * @type {string}
   * @memberof SystemRs
   */
  message?: string | null
}
/**
 * Valid Invitation Code Rs Model
 * @export
 * @interface ValidInvitationCodeRs
 */
export interface ValidInvitationCodeRs {
  /**
   * 執行狀態
   * @type {boolean}
   * @memberof ValidInvitationCodeRs
   */
  status?: boolean
  /**
   * 訊息
   * @type {string}
   * @memberof ValidInvitationCodeRs
   */
  message?: string | null
}
/**
 * Verify Email Verification Code Rq Model
 * @export
 * @interface VerifyEmailVerificationCodeRq
 */
export interface VerifyEmailVerificationCodeRq {
  /**
   * Correlation Id
   * @type {string}
   * @memberof VerifyEmailVerificationCodeRq
   */
  correlationId?: string
  /**
   * New Email
   * @type {string}
   * @memberof VerifyEmailVerificationCodeRq
   */
  emailAddress?: string | null
  /**
   * Verification Code
   * @type {string}
   * @memberof VerifyEmailVerificationCodeRq
   */
  verificationCode?: string | null
}
/**
 * Verify Email Verification Code Rs Model
 * @export
 * @interface VerifyEmailVerificationCodeRs
 */
export interface VerifyEmailVerificationCodeRs {
  /**
   * 執行狀態
   * @type {boolean}
   * @memberof VerifyEmailVerificationCodeRs
   */
  status?: boolean
  /**
   * 訊息
   * @type {string}
   * @memberof VerifyEmailVerificationCodeRs
   */
  message?: string | null
}

/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Authorize
     * @param {string} [mode] mode
     * @param {string} [provider] provider
     * @param {string} [invitationCode] invitationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthorizationAuthorize: async (
      mode?: string,
      provider?: string,
      invitationCode?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/connect/authorize`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (mode !== undefined) {
        localVarQueryParameter['mode'] = mode
      }

      if (provider !== undefined) {
        localVarQueryParameter['provider'] = provider
      }

      if (invitationCode !== undefined) {
        localVarQueryParameter['invitationCode'] = invitationCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Exchange
     * @param {string} grantType
     * @param {string} clientId
     * @param {string} clientSecret
     * @param {string} [username]
     * @param {string} [password]
     * @param {string} [scope]
     * @param {string} [code]
     * @param {string} [redirectUri]
     * @param {string} [codeVerifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthorizationExchange: async (
      grantType: string,
      clientId: string,
      clientSecret: string,
      username?: string,
      password?: string,
      scope?: string,
      code?: string,
      redirectUri?: string,
      codeVerifier?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'grantType' is not null or undefined
      assertParamExists('postAuthorizationExchange', 'grantType', grantType)
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('postAuthorizationExchange', 'clientId', clientId)
      // verify required parameter 'clientSecret' is not null or undefined
      assertParamExists('postAuthorizationExchange', 'clientSecret', clientSecret)
      const localVarPath = `/connect/token`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new URLSearchParams()

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (grantType !== undefined) {
        localVarFormParams.set('grant_type', grantType as any)
      }

      if (clientId !== undefined) {
        localVarFormParams.set('client_id', clientId as any)
      }

      if (clientSecret !== undefined) {
        localVarFormParams.set('client_secret', clientSecret as any)
      }

      if (username !== undefined) {
        localVarFormParams.set('username', username as any)
      }

      if (password !== undefined) {
        localVarFormParams.set('password', password as any)
      }

      if (scope !== undefined) {
        localVarFormParams.set('scope', scope as any)
      }

      if (code !== undefined) {
        localVarFormParams.set('code', code as any)
      }

      if (redirectUri !== undefined) {
        localVarFormParams.set('redirect_uri', redirectUri as any)
      }

      if (codeVerifier !== undefined) {
        localVarFormParams.set('code_verifier', codeVerifier as any)
      }

      localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = localVarFormParams.toString()

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Authorize
     * @param {string} [mode] mode
     * @param {string} [provider] provider
     * @param {string} [invitationCode] invitationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAuthorizationAuthorize(
      mode?: string,
      provider?: string,
      invitationCode?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizationAuthorize(
        mode,
        provider,
        invitationCode,
        options
      )
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['AuthorizationApi.getAuthorizationAuthorize']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary Exchange
     * @param {string} grantType
     * @param {string} clientId
     * @param {string} clientSecret
     * @param {string} [username]
     * @param {string} [password]
     * @param {string} [scope]
     * @param {string} [code]
     * @param {string} [redirectUri]
     * @param {string} [codeVerifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postAuthorizationExchange(
      grantType: string,
      clientId: string,
      clientSecret: string,
      username?: string,
      password?: string,
      scope?: string,
      code?: string,
      redirectUri?: string,
      codeVerifier?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postAuthorizationExchange(
        grantType,
        clientId,
        clientSecret,
        username,
        password,
        scope,
        code,
        redirectUri,
        codeVerifier,
        options
      )
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['AuthorizationApi.postAuthorizationExchange']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    }
  }
}

/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthorizationApiFp(configuration)
  return {
    /**
     *
     * @summary Authorize
     * @param {string} [mode] mode
     * @param {string} [provider] provider
     * @param {string} [invitationCode] invitationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthorizationAuthorize(
      mode?: string,
      provider?: string,
      invitationCode?: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .getAuthorizationAuthorize(mode, provider, invitationCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Exchange
     * @param {string} grantType
     * @param {string} clientId
     * @param {string} clientSecret
     * @param {string} [username]
     * @param {string} [password]
     * @param {string} [scope]
     * @param {string} [code]
     * @param {string} [redirectUri]
     * @param {string} [codeVerifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthorizationExchange(
      grantType: string,
      clientId: string,
      clientSecret: string,
      username?: string,
      password?: string,
      scope?: string,
      code?: string,
      redirectUri?: string,
      codeVerifier?: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .postAuthorizationExchange(
          grantType,
          clientId,
          clientSecret,
          username,
          password,
          scope,
          code,
          redirectUri,
          codeVerifier,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
  /**
   *
   * @summary Authorize
   * @param {string} [mode] mode
   * @param {string} [provider] provider
   * @param {string} [invitationCode] invitationCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthorizationApi
   */
  public getAuthorizationAuthorize(
    mode?: string,
    provider?: string,
    invitationCode?: string,
    options?: AxiosRequestConfig
  ) {
    return AuthorizationApiFp(this.configuration)
      .getAuthorizationAuthorize(mode, provider, invitationCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Exchange
   * @param {string} grantType
   * @param {string} clientId
   * @param {string} clientSecret
   * @param {string} [username]
   * @param {string} [password]
   * @param {string} [scope]
   * @param {string} [code]
   * @param {string} [redirectUri]
   * @param {string} [codeVerifier]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthorizationApi
   */
  public postAuthorizationExchange(
    grantType: string,
    clientId: string,
    clientSecret: string,
    username?: string,
    password?: string,
    scope?: string,
    code?: string,
    redirectUri?: string,
    codeVerifier?: string,
    options?: AxiosRequestConfig
  ) {
    return AuthorizationApiFp(this.configuration)
      .postAuthorizationExchange(
        grantType,
        clientId,
        clientSecret,
        username,
        password,
        scope,
        code,
        redirectUri,
        codeVerifier,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RegisterApi - axios parameter creator
 * @export
 */
export const RegisterApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 驗證邀請碼
     * @param {string} [invitationCode] 邀請碼
     * @param {string} [invitationEmail] email
     * @param {string} [checksum]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRegisterValidinvitationcode: async (
      invitationCode?: string,
      invitationEmail?: string,
      checksum?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/register/ValidInvitationCode`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (invitationCode !== undefined) {
        localVarQueryParameter['invitationCode'] = invitationCode
      }

      if (invitationEmail !== undefined) {
        localVarQueryParameter['invitationEmail'] = invitationEmail
      }

      if (checksum !== undefined) {
        localVarQueryParameter['checksum'] = checksum
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary 註冊外部帳號
     * @param {ExternalRq} [externalRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterExternal: async (externalRq?: ExternalRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/register/external`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = serializeDataIfNeeded(externalRq, localVarRequestOptions, configuration)

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary 申請變更密碼
     * @param {RequestForgotPasswordApplyRq} [requestForgotPasswordApplyRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterRequestforgotpasswordapply: async (
      requestForgotPasswordApplyRq?: RequestForgotPasswordApplyRq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/register/RequestForgotPasswordApply`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestForgotPasswordApplyRq,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary 請求產生新帳號申請
     * @param {RequestNewAccountApplyRq} [requestNewAccountApplyRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterRequestnewaccountapply: async (
      requestNewAccountApplyRq?: RequestNewAccountApplyRq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/register/RequestNewAccountApply`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestNewAccountApplyRq,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary 重設密碼
     * @param {ResetPasswordRq} [resetPasswordRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterResetpassword: async (
      resetPasswordRq?: ResetPasswordRq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/register/ResetPassword`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRq, localVarRequestOptions, configuration)

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary 註冊系統帳號
     * @param {SystemRq} [systemRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterSystem: async (systemRq?: SystemRq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/register/system`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = serializeDataIfNeeded(systemRq, localVarRequestOptions, configuration)

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary 驗證
     * @param {VerifyEmailVerificationCodeRq} [verifyEmailVerificationCodeRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterVerifyemailverificationcode: async (
      verifyEmailVerificationCodeRq?: VerifyEmailVerificationCodeRq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/register/VerifyEmailVerificationCode`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = serializeDataIfNeeded(
        verifyEmailVerificationCodeRq,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RegisterApi - functional programming interface
 * @export
 */
export const RegisterApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RegisterApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary 驗證邀請碼
     * @param {string} [invitationCode] 邀請碼
     * @param {string} [invitationEmail] email
     * @param {string} [checksum]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRegisterValidinvitationcode(
      invitationCode?: string,
      invitationEmail?: string,
      checksum?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidInvitationCodeRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRegisterValidinvitationcode(
        invitationCode,
        invitationEmail,
        checksum,
        options
      )
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['RegisterApi.getRegisterValidinvitationcode']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary 註冊外部帳號
     * @param {ExternalRq} [externalRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postRegisterExternal(
      externalRq?: ExternalRq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postRegisterExternal(externalRq, options)
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['RegisterApi.postRegisterExternal']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary 申請變更密碼
     * @param {RequestForgotPasswordApplyRq} [requestForgotPasswordApplyRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postRegisterRequestforgotpasswordapply(
      requestForgotPasswordApplyRq?: RequestForgotPasswordApplyRq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestForgotPasswordApplyRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postRegisterRequestforgotpasswordapply(
        requestForgotPasswordApplyRq,
        options
      )
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['RegisterApi.postRegisterRequestforgotpasswordapply']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary 請求產生新帳號申請
     * @param {RequestNewAccountApplyRq} [requestNewAccountApplyRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postRegisterRequestnewaccountapply(
      requestNewAccountApplyRq?: RequestNewAccountApplyRq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestNewAccountApplyRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postRegisterRequestnewaccountapply(
        requestNewAccountApplyRq,
        options
      )
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['RegisterApi.postRegisterRequestnewaccountapply']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary 重設密碼
     * @param {ResetPasswordRq} [resetPasswordRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postRegisterResetpassword(
      resetPasswordRq?: ResetPasswordRq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postRegisterResetpassword(resetPasswordRq, options)
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['RegisterApi.postRegisterResetpassword']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary 註冊系統帳號
     * @param {SystemRq} [systemRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postRegisterSystem(
      systemRq?: SystemRq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postRegisterSystem(systemRq, options)
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['RegisterApi.postRegisterSystem']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary 驗證
     * @param {VerifyEmailVerificationCodeRq} [verifyEmailVerificationCodeRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postRegisterVerifyemailverificationcode(
      verifyEmailVerificationCodeRq?: VerifyEmailVerificationCodeRq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmailVerificationCodeRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postRegisterVerifyemailverificationcode(
        verifyEmailVerificationCodeRq,
        options
      )
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['RegisterApi.postRegisterVerifyemailverificationcode']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    }
  }
}

/**
 * RegisterApi - factory interface
 * @export
 */
export const RegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = RegisterApiFp(configuration)
  return {
    /**
     *
     * @summary 驗證邀請碼
     * @param {string} [invitationCode] 邀請碼
     * @param {string} [invitationEmail] email
     * @param {string} [checksum]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRegisterValidinvitationcode(
      invitationCode?: string,
      invitationEmail?: string,
      checksum?: string,
      options?: any
    ): AxiosPromise<ValidInvitationCodeRs> {
      return localVarFp
        .getRegisterValidinvitationcode(invitationCode, invitationEmail, checksum, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary 註冊外部帳號
     * @param {ExternalRq} [externalRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterExternal(externalRq?: ExternalRq, options?: any): AxiosPromise<ExternalRs> {
      return localVarFp.postRegisterExternal(externalRq, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary 申請變更密碼
     * @param {RequestForgotPasswordApplyRq} [requestForgotPasswordApplyRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterRequestforgotpasswordapply(
      requestForgotPasswordApplyRq?: RequestForgotPasswordApplyRq,
      options?: any
    ): AxiosPromise<RequestForgotPasswordApplyRs> {
      return localVarFp
        .postRegisterRequestforgotpasswordapply(requestForgotPasswordApplyRq, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary 請求產生新帳號申請
     * @param {RequestNewAccountApplyRq} [requestNewAccountApplyRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterRequestnewaccountapply(
      requestNewAccountApplyRq?: RequestNewAccountApplyRq,
      options?: any
    ): AxiosPromise<RequestNewAccountApplyRs> {
      return localVarFp
        .postRegisterRequestnewaccountapply(requestNewAccountApplyRq, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary 重設密碼
     * @param {ResetPasswordRq} [resetPasswordRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterResetpassword(resetPasswordRq?: ResetPasswordRq, options?: any): AxiosPromise<ResetPasswordRs> {
      return localVarFp.postRegisterResetpassword(resetPasswordRq, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary 註冊系統帳號
     * @param {SystemRq} [systemRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterSystem(systemRq?: SystemRq, options?: any): AxiosPromise<SystemRs> {
      return localVarFp.postRegisterSystem(systemRq, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary 驗證
     * @param {VerifyEmailVerificationCodeRq} [verifyEmailVerificationCodeRq] rq model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRegisterVerifyemailverificationcode(
      verifyEmailVerificationCodeRq?: VerifyEmailVerificationCodeRq,
      options?: any
    ): AxiosPromise<VerifyEmailVerificationCodeRs> {
      return localVarFp
        .postRegisterVerifyemailverificationcode(verifyEmailVerificationCodeRq, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RegisterApi - object-oriented interface
 * @export
 * @class RegisterApi
 * @extends {BaseAPI}
 */
export class RegisterApi extends BaseAPI {
  /**
   *
   * @summary 驗證邀請碼
   * @param {string} [invitationCode] 邀請碼
   * @param {string} [invitationEmail] email
   * @param {string} [checksum]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public getRegisterValidinvitationcode(
    invitationCode?: string,
    invitationEmail?: string,
    checksum?: string,
    options?: AxiosRequestConfig
  ) {
    return RegisterApiFp(this.configuration)
      .getRegisterValidinvitationcode(invitationCode, invitationEmail, checksum, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary 註冊外部帳號
   * @param {ExternalRq} [externalRq] rq model
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public postRegisterExternal(externalRq?: ExternalRq, options?: AxiosRequestConfig) {
    return RegisterApiFp(this.configuration)
      .postRegisterExternal(externalRq, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary 申請變更密碼
   * @param {RequestForgotPasswordApplyRq} [requestForgotPasswordApplyRq] rq model
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public postRegisterRequestforgotpasswordapply(
    requestForgotPasswordApplyRq?: RequestForgotPasswordApplyRq,
    options?: AxiosRequestConfig
  ) {
    return RegisterApiFp(this.configuration)
      .postRegisterRequestforgotpasswordapply(requestForgotPasswordApplyRq, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary 請求產生新帳號申請
   * @param {RequestNewAccountApplyRq} [requestNewAccountApplyRq] rq model
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public postRegisterRequestnewaccountapply(
    requestNewAccountApplyRq?: RequestNewAccountApplyRq,
    options?: AxiosRequestConfig
  ) {
    return RegisterApiFp(this.configuration)
      .postRegisterRequestnewaccountapply(requestNewAccountApplyRq, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary 重設密碼
   * @param {ResetPasswordRq} [resetPasswordRq] rq model
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public postRegisterResetpassword(resetPasswordRq?: ResetPasswordRq, options?: AxiosRequestConfig) {
    return RegisterApiFp(this.configuration)
      .postRegisterResetpassword(resetPasswordRq, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary 註冊系統帳號
   * @param {SystemRq} [systemRq] rq model
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public postRegisterSystem(systemRq?: SystemRq, options?: AxiosRequestConfig) {
    return RegisterApiFp(this.configuration)
      .postRegisterSystem(systemRq, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary 驗證
   * @param {VerifyEmailVerificationCodeRq} [verifyEmailVerificationCodeRq] rq model
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public postRegisterVerifyemailverificationcode(
    verifyEmailVerificationCodeRq?: VerifyEmailVerificationCodeRq,
    options?: AxiosRequestConfig
  ) {
    return RegisterApiFp(this.configuration)
      .postRegisterVerifyemailverificationcode(verifyEmailVerificationCodeRq, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 抓取系統版本資訊
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSystemGetapplicationversion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/System/GetApplicationVersion`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary 抓取系統版本資訊
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSystemGetapplicationversion(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppInfoApiRs>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSystemGetapplicationversion(options)
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['SystemApi.getSystemGetapplicationversion']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    }
  }
}

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SystemApiFp(configuration)
  return {
    /**
     *
     * @summary 抓取系統版本資訊
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSystemGetapplicationversion(options?: any): AxiosPromise<AppInfoApiRs> {
      return localVarFp.getSystemGetapplicationversion(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
  /**
   *
   * @summary 抓取系統版本資訊
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public getSystemGetapplicationversion(options?: AxiosRequestConfig) {
    return SystemApiFp(this.configuration)
      .getSystemGetapplicationversion(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserinfoApi - axios parameter creator
 * @export
 */
export const UserinfoApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Userinfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserinfoUserinfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/connect/userinfo`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Userinfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postUserinfoUserinfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/connect/userinfo`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication OpenIddict.Server.AspNetCore required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserinfoApi - functional programming interface
 * @export
 */
export const UserinfoApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserinfoApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Userinfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserinfoUserinfo(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUserinfoUserinfo(options)
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['UserinfoApi.getUserinfoUserinfo']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    },
    /**
     *
     * @summary Userinfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postUserinfoUserinfo(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postUserinfoUserinfo(options)
      const index = configuration?.serverIndex ?? 0
      const operationBasePath = operationServerMap['UserinfoApi.postUserinfoUserinfo']?.[index]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath)
    }
  }
}

/**
 * UserinfoApi - factory interface
 * @export
 */
export const UserinfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UserinfoApiFp(configuration)
  return {
    /**
     *
     * @summary Userinfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserinfoUserinfo(options?: any): AxiosPromise<void> {
      return localVarFp.getUserinfoUserinfo(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Userinfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postUserinfoUserinfo(options?: any): AxiosPromise<void> {
      return localVarFp.postUserinfoUserinfo(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserinfoApi - object-oriented interface
 * @export
 * @class UserinfoApi
 * @extends {BaseAPI}
 */
export class UserinfoApi extends BaseAPI {
  /**
   *
   * @summary Userinfo
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserinfoApi
   */
  public getUserinfoUserinfo(options?: AxiosRequestConfig) {
    return UserinfoApiFp(this.configuration)
      .getUserinfoUserinfo(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Userinfo
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserinfoApi
   */
  public postUserinfoUserinfo(options?: AxiosRequestConfig) {
    return UserinfoApiFp(this.configuration)
      .postUserinfoUserinfo(options)
      .then((request) => request(this.axios, this.basePath))
  }
}
